<template>
  <section class="top-destinations">
    <div class="destinations-list">
      <pu-search-link
        v-for="destination of destinationsList"
        :key="destination.hierarchy + lang"
        :hierarchy-path="destination.hierarchy"
        :modify-filters="{ facets: undefined }"
      >
        <span class="location">{{ destination.name }}</span>
        <span
          v-if="lang !== 'en-gb' && destination.additionalDisplayName"
          class="subtext"
          >{{ destination.additionalDisplayName }}</span
        >
      </pu-search-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useLazyAsyncData, useRoute } from 'nuxt/app'
import { computed, unref } from 'vue'
import { AjaxFetchTopDestinationsRepository } from '~/apps/top-destinations/AjaxFetchTopDestinationsRepository'
import { TopDestination } from '~/apps/top-destinations/schemas'

const props = defineProps<{
  destinations?: TopDestination[]
}>()

const route = useRoute()
const fetchOptions = {
  retry: 0,
  timeout: 10000,
}
const lang = route.params.lang || 'en-gb'
const destinationsRepository = new AjaxFetchTopDestinationsRepository()

const { data: destinationsData } = props.destinations
  ? { data: props.destinations }
  : useLazyAsyncData(`destinations-${lang}`, async () => {
      return await destinationsRepository.getAll(lang, fetchOptions)
    })

const destinationsList = computed(() => unref(destinationsData))
</script>
<style scoped>
.top-destinations {
  overflow-x: auto;
  overflow-y: visible;
  scroll-snap-type: x mandatory;
}
.destinations-list {
  display: flex;
  flex-wrap: wrap;
  min-width: 220vw;
  padding: 0.5em 0.4em 1em 1.4em;
}

.top-destinations::-webkit-scrollbar {
  display: none;
}

a {
  align-items: center;
  background: #185ba1;
  border-radius: 6em;
  color: white;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  font-weight: bold;
  justify-content: center;
  line-height: 1.15;
  margin: 0.5em 1em 0.5em 0;
  min-height: 2.25em;
  padding: 0.3em 1.5em;
  text-decoration: none;
  max-width: 110vw;
}

.location {
  font-size: var(--body);
}

.subtext {
  font-size: var(--small);
  font-weight: normal;
  color: #c3d4e5;
}
.destination {
  align-items: center;
  border-radius: 0.3em;
  color: white;
  display: flex;
  line-height: 1;
  margin-bottom: 0.2em;
  min-height: 6em;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  text-shadow: 0.05em 0.05em 0.3em rgba(0, 0, 0, 0.5);
  width: 100%;
}
</style>
